module.exports = __webpack_public_path__ + "static/media/view-blog-category.bc03e7d0.png";